import React from 'react';
import { Breadcrumb as BreadcrumbComponent } from 'antd';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { shortText } from 'src/utils/string';

interface BreadcrumbItem {
  name: string;
  path: string;
}

interface BreadcrumbProps {
  breadcrumbItems: BreadcrumbItem[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ breadcrumbItems }) => {
  return (
    <BreadcrumbStyle>
      {breadcrumbItems.map((item, index) => (
        <BreadcrumbStyle.Item key={index}>
          <Link to={item.path} className="path-name">
            {index + 1 < breadcrumbItems.length
              ? shortText(item.name, 15)
              : item.name}
          </Link>
        </BreadcrumbStyle.Item>
      ))}
    </BreadcrumbStyle>
  );
};

export default Breadcrumb;

const BreadcrumbStyle = styled(BreadcrumbComponent)`
  li {
    display: flex;
    font-size: 25px;
    font-weight: bold;
  }

  &.ant-breadcrumb a:hover,
  &.ant-breadcrumb li:last-child a {
    color: #0c3255;
  }
`;
